/**
 * This code was AUTOGENERATED using the Codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun Codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  containsBytes,
  getU8Encoder,
  type Address,
  type ReadonlyUint8Array,
} from '@solana/kit';
import {
  type ParsedAcceptProgramAuthorityInstruction,
  type ParsedCancelAuthorityTransferInstruction,
  type ParsedCheckAuthorizationInstruction,
  type ParsedClaimRewardsInstruction,
  type ParsedCloseStakeAccountInstruction,
  type ParsedFinalizeRewardRateChangeInstruction,
  type ParsedFundRewardsInstruction,
  type ParsedGetAuthorizedCreatorsInstruction,
  type ParsedInitializePoolInstruction,
  type ParsedInitializeProgramAuthorityInstruction,
  type ParsedManageAuthorizedCreatorsInstruction,
  type ParsedStakeInstruction,
  type ParsedTransferProgramAuthorityInstruction,
  type ParsedUnstakeInstruction,
  type ParsedUpdatePoolInstruction,
} from '../instructions';

export const STAKE_POOL_PROGRAM_ADDRESS =
  '8PtjrGvKNeZt2vCmRkSPGjss7TAFhvxux2N8r67UMKBx' as Address<'8PtjrGvKNeZt2vCmRkSPGjss7TAFhvxux2N8r67UMKBx'>;

export enum StakePoolAccount {
  StakePool,
  StakeAccount,
  ProgramAuthority,
}

export enum StakePoolInstruction {
  InitializePool,
  Stake,
  Unstake,
  ClaimRewards,
  UpdatePool,
  FundRewards,
  CloseStakeAccount,
  FinalizeRewardRateChange,
  InitializeProgramAuthority,
  ManageAuthorizedCreators,
  TransferProgramAuthority,
  AcceptProgramAuthority,
  CancelAuthorityTransfer,
  GetAuthorizedCreators,
  CheckAuthorization,
}

export function identifyStakePoolInstruction(
  instruction: { data: ReadonlyUint8Array } | ReadonlyUint8Array
): StakePoolInstruction {
  const data = 'data' in instruction ? instruction.data : instruction;
  if (containsBytes(data, getU8Encoder().encode(0), 0)) {
    return StakePoolInstruction.InitializePool;
  }
  if (containsBytes(data, getU8Encoder().encode(1), 0)) {
    return StakePoolInstruction.Stake;
  }
  if (containsBytes(data, getU8Encoder().encode(2), 0)) {
    return StakePoolInstruction.Unstake;
  }
  if (containsBytes(data, getU8Encoder().encode(3), 0)) {
    return StakePoolInstruction.ClaimRewards;
  }
  if (containsBytes(data, getU8Encoder().encode(4), 0)) {
    return StakePoolInstruction.UpdatePool;
  }
  if (containsBytes(data, getU8Encoder().encode(5), 0)) {
    return StakePoolInstruction.FundRewards;
  }
  if (containsBytes(data, getU8Encoder().encode(6), 0)) {
    return StakePoolInstruction.CloseStakeAccount;
  }
  if (containsBytes(data, getU8Encoder().encode(7), 0)) {
    return StakePoolInstruction.FinalizeRewardRateChange;
  }
  if (containsBytes(data, getU8Encoder().encode(8), 0)) {
    return StakePoolInstruction.InitializeProgramAuthority;
  }
  if (containsBytes(data, getU8Encoder().encode(9), 0)) {
    return StakePoolInstruction.ManageAuthorizedCreators;
  }
  if (containsBytes(data, getU8Encoder().encode(10), 0)) {
    return StakePoolInstruction.TransferProgramAuthority;
  }
  if (containsBytes(data, getU8Encoder().encode(11), 0)) {
    return StakePoolInstruction.AcceptProgramAuthority;
  }
  if (containsBytes(data, getU8Encoder().encode(12), 0)) {
    return StakePoolInstruction.CancelAuthorityTransfer;
  }
  if (containsBytes(data, getU8Encoder().encode(13), 0)) {
    return StakePoolInstruction.GetAuthorizedCreators;
  }
  if (containsBytes(data, getU8Encoder().encode(14), 0)) {
    return StakePoolInstruction.CheckAuthorization;
  }
  throw new Error(
    'The provided instruction could not be identified as a stakePool instruction.'
  );
}

export type ParsedStakePoolInstruction<
  TProgram extends string = '8PtjrGvKNeZt2vCmRkSPGjss7TAFhvxux2N8r67UMKBx',
> =
  | ({
      instructionType: StakePoolInstruction.InitializePool;
    } & ParsedInitializePoolInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.Stake;
    } & ParsedStakeInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.Unstake;
    } & ParsedUnstakeInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.ClaimRewards;
    } & ParsedClaimRewardsInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.UpdatePool;
    } & ParsedUpdatePoolInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.FundRewards;
    } & ParsedFundRewardsInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.CloseStakeAccount;
    } & ParsedCloseStakeAccountInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.FinalizeRewardRateChange;
    } & ParsedFinalizeRewardRateChangeInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.InitializeProgramAuthority;
    } & ParsedInitializeProgramAuthorityInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.ManageAuthorizedCreators;
    } & ParsedManageAuthorizedCreatorsInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.TransferProgramAuthority;
    } & ParsedTransferProgramAuthorityInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.AcceptProgramAuthority;
    } & ParsedAcceptProgramAuthorityInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.CancelAuthorityTransfer;
    } & ParsedCancelAuthorityTransferInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.GetAuthorizedCreators;
    } & ParsedGetAuthorizedCreatorsInstruction<TProgram>)
  | ({
      instructionType: StakePoolInstruction.CheckAuthorization;
    } & ParsedCheckAuthorizationInstruction<TProgram>);
